import { HateoasResource, Resource } from "@lagoshny/ngx-hateoas-client";
import { BaseEntity } from "@app/models/rest/base-entity";
import { RuleType } from "@app/models/enums/resource-rule-type";

@HateoasResource("resourceRules")
export class ResourceRule extends BaseEntity {
  ruleType: RuleType;
  ruleValue: string;
  resource: Resource;
}
